<template>
  <div class="timeline-container">
    <el-row v-if="userInfo" :gutter="24" class="timeline-layout">

      <el-col :md="6" :lg="5" class="hidden-sm-and-down">
        <div class="sticky-sidebar">
          <el-card class="user-profile-card shadow-soft" :body-style="{ padding: '0' }">
            <div class="card-banner" />
            <div class="profile-content">
              <div class="avatar-container">
                <router-link :to="`/vod/user/${userInfo.userId}`">
                  <el-avatar :size="80" :src="userInfo.avatarUrl" class="main-avatar" />
                  <i v-if="userInfo.isVip" class="el-icon-star-on vip-icon" title="大会员" />
                </router-link>
              </div>
              <div class="user-info">
                <h3 class="username">{{ userInfo.screenName }}</h3>
                <p class="user-tag">UID: {{ userInfo.userId }}</p>
              </div>
              <div class="stats-row">
                <router-link :to="`/vod/user/${userInfo.userId}/following`" class="stat-item">
                  <span class="num">{{ userInfo.following }}</span>
                  <span class="label">关注</span>
                </router-link>
                <router-link :to="`/vod/user/${userInfo.userId}/follower`" class="stat-item">
                  <span class="num">{{ userInfo.follower }}</span>
                  <span class="label">粉丝</span>
                </router-link>
                <div class="stat-item">
                  <span class="num">{{ dataList.length }}</span>
                  <span class="label">动态</span>
                </div>
              </div>
              <div class="signature-section">
                <p class="sig-title">个人介绍</p>
                <p class="sig-content">{{ userInfo.signature || '这个人很懒，什么都没留下...' }}</p>
              </div>
            </div>
          </el-card>
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="12" :lg="13">
        <div class="post-wrapper shadow-soft">
          <text-card />
        </div>

        <div
          v-infinite-scroll="load"
          class="scroll-viewport shadow-soft"
          :infinite-scroll-disabled="loading || noMore"
          :infinite-scroll-distance="50"
          :infinite-scroll-immediate="false"
        >
          <div class="timeline-feed">
            <div v-for="(video, index) in dataList" :key="index" class="feed-card-item fade-in">
              <side-video-card :video="video" />
            </div>

            <div v-if="loading" class="loading-box">
              <i class="el-icon-loading" />
              <span>内容正在赶来...</span>
            </div>

            <div v-if="noMore && dataList.length > 0" class="end-box">
              <span class="end-text">已经到底啦 ✨</span>
            </div>

            <el-empty v-if="dataList.length === 0 && !loading" description="暂时没有新动态" />
          </div>
        </div>
      </el-col>

      <el-col :md="6" :lg="6" class="hidden-md-and-down">
        <div class="sticky-sidebar">
          <el-card class="hot-card shadow-soft" :body-style="{ padding: '15px' }">
            <div slot="header" class="card-header">
              <span class="header-title"><i class="el-icon-medal" /> 社区热议</span>
              <el-button type="text" icon="el-icon-refresh">换一换</el-button>
            </div>
            <div class="topic-list">
              <div class="topic-item"><span class="rank">1</span><span class="name"># 2026年度视频征集</span><el-tag size="mini" type="danger" effect="plain">热</el-tag></div>
              <div class="topic-item"><span class="rank">2</span><span class="name"># 科技数码新趋势</span></div>
              <div class="topic-item"><span class="rank">3</span><span class="name"># 春日摄影大赛</span></div>
            </div>
          </el-card>

          <div class="footer-links">
            <p>© 2026 Gemini Video 社区</p>
            <p>关于我们 · 用户协议 · 帮助中心</p>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import TextCard from '@/components/card/TextCard'
import SideVideoCard from '@/components/card/SideVideoCard'
import { videoTimeline } from '@/api/vod'

export default {
  name: 'Timeline',
  components: { TextCard, SideVideoCard },
  data() {
    return {
      nextId: 0,
      userInfo: null,
      dataList: [],
      loading: false,
      noMore: false
    }
  },
  created() {
    const loginUser = this.$store.state.userInfo
    if (!loginUser) {
      this.$router.push('/login')
      return
    }
    this.userInfo = loginUser
    document.title = `动态 - ${loginUser.screenName}`
    this.videoTimelineWrapper(this.nextId)
  },
  methods: {
    load() {
      if (this.loading || this.noMore) return
      this.videoTimelineWrapper(this.nextId)
    },
    videoTimelineWrapper(nextId) {
      this.loading = true
      videoTimeline(nextId).then(resp => {
        if (resp.code === 0) {
          const newList = resp.data.list
          if (newList && newList.length > 0) {
            this.dataList = [...this.dataList, ...newList]
            this.nextId = resp.data.nextId
          } else {
            this.noMore = true
          }
        }
      }).finally(() => {
        setTimeout(() => { this.loading = false }, 300)
      })
    }
  }
}
</script>

<style scoped>
.timeline-container {
  background-color: #f6f7f9;
  height: 100vh; /* 撑满视口 */
  padding: 24px 0;
  overflow: hidden; /* 防止背景滚动 */
}

.timeline-layout {
  max-width: 1280px;
  margin: 0 auto !important;
  height: 100%;
}

/* 核心滚动容器样式 */
.scroll-viewport {
  background: #fff;
  border-radius: 12px;
  /* 计算高度：视口高度 - 顶部Padding - 发动态框高度 - 底部余量 */
  height: calc(100vh - 180px);
  overflow-y: auto;
  scrollbar-width: thin; /* 火狐滚动条美化 */
  scrollbar-color: #e3e5e7 transparent;
}

/* Chrome/Safari 滚动条美化 */
.scroll-viewport::-webkit-scrollbar {
  width: 6px;
}
.scroll-viewport::-webkit-scrollbar-thumb {
  background: #e3e5e7;
  border-radius: 10px;
}
.scroll-viewport::-webkit-scrollbar-track {
  background: transparent;
}

.timeline-feed {
  padding: 16px;
}

.feed-card-item {
  border-bottom: 1px solid #f1f2f3;
  padding: 16px 0;
  transition: background 0.2s;
}

.feed-card-item:last-child {
  border-bottom: none;
}

.feed-card-item:hover {
  background-color: #fafbfc;
}

/* 基础辅助类 */
.sticky-sidebar {
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.shadow-soft {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04) !important;
  border: 1px solid rgba(230, 230, 230, 0.6) !important;
}

/* --- 侧边栏及其他样式保持原样 (省略以保持简洁) --- */
.card-banner { height: 80px; background: linear-gradient(135deg, #a1c4fd 0%, #c2e9fb 100%); }
.profile-content { padding: 0 16px 20px; text-align: center; }
.avatar-container { margin-top: -40px; position: relative; display: inline-block; }
.main-avatar { border: 4px solid #fff; box-shadow: 0 4px 10px rgba(0,0,0,0.1); }
.username { margin: 12px 0 4px; font-size: 18px; font-weight: 600; }
.stats-row { display: flex; justify-content: space-around; border-top: 1px solid #f1f2f3; padding-top: 16px; }
.stat-item { text-decoration: none; color: inherit; display: flex; flex-direction: column; align-items: center; }
.stat-item .num { font-size: 16px; font-weight: 600; }
.stat-item .label { font-size: 12px; color: #9499a0; }
.signature-section { text-align: left; background: #f6f7f8; padding: 12px; border-radius: 8px; margin-top: 15px; }
.post-wrapper { margin-bottom: 16px; border-radius: 12px; }
.loading-box, .end-box { text-align: center; padding: 24px; color: #9499a0; font-size: 14px; }
.topic-list { display: flex; flex-direction: column; gap: 14px; }
.topic-item { display: flex; align-items: center; gap: 10px; cursor: pointer; font-size: 14px; }
.rank { font-weight: bold; width: 20px; }
.fade-in { animation: fadeIn 0.4s ease-out; }
@keyframes fadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }

@media screen and (max-width: 768px) {
  .scroll-viewport { height: calc(100vh - 140px); }
}
</style>
